import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@app/providers/AppProviders";
import { router } from "@app/router/router";

export function AppWithProviders() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
